var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ov2024-list__search__items"},[_vm._v(" "+_vm._s(_vm.getTelepulesNev)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }